<div class="custom-pagination-container">
  <!-- 1. Page Size Selector -->
  <div class="page-size-section">
    <span class="page-size-label">Items per page:</span>
    <select class="page-size-select" [value]="pageSize" (change)="onPageSizeChange($event)">
      <option *ngFor="let size of pageSizeOptions" [value]="size" [selected]="size === pageSize">{{size}}</option>
    </select>
  </div>

  <!-- 2. Range Label -->
  <div class="range-label-section">
    <span>{{getRangeLabel()}}</span>
  </div>

  <!-- 3. Page Buttons -->
  <div class="page-buttons-section">
    <ng-container *ngFor="let item of getPageSequence()">
      <span *ngIf="item === '...'" class="dots">...</span>
      <button *ngIf="item !== '...'"
              type="button"
              class="page-btn"
              [class.active]="item === pageIndex"
              (click)="onPageClick(item)">
        {{item + 1}}
      </button>
    </ng-container>
  </div>

  <!-- 4. Navigation Arrows -->
  <div class="nav-arrows-section">
    <button type="button"
            class="arrow-btn"
            [disabled]="pageIndex === 0"
            (click)="onPrevClick()">
      ‹
    </button>
    <button type="button"
            class="arrow-btn"
            [disabled]="pageIndex >= totalPages - 1"
            (click)="onNextClick()">
      ›
    </button>
  </div>
</div>
